import React from "react";
import MasterListToolbar from "../../../../components/masterData/MasterListToolbar";
import { MasterSelectOption } from "../../../../components/masterData/MasterSelect";

export function ParishListToolbar({
  selectedCategoryId,
  categoryList,
  selectedDeaneryId,
  deaneryList,
  searchKey,
  onCategoryChange,
  onDeaneryChange,
  onSearch,
  onClear,
}: {
  selectedCategoryId: string;
  categoryList: any[];
  selectedDeaneryId: string;
  deaneryList: any[];
  searchKey: string;
  onCategoryChange: (categoryId: string) => void;
  onDeaneryChange: (deaneryId: string) => void;
  onSearch: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClear?: () => void;
}) {
  const options: MasterSelectOption[] = [...categoryList]
    .sort((a, b) => {
      if (a.name === "OTHER") return 1;
      if (b.name === "OTHER") return -1;
      return 0;
    })
    .map((category) => ({ value: category.id, label: category.name }));

  const deaneryOptions: MasterSelectOption[] = deaneryList
    .filter(
      (deanery) =>
        !selectedCategoryId ||
        String(deanery.parishCategoryId) === String(selectedCategoryId),
    )
    .map((deanery) => ({ value: deanery.id, label: deanery.deaneryName }));

  return (
    <MasterListToolbar
      selectValue={selectedCategoryId}
      selectPlaceholder="All Categories"
      selectOptions={options}
      onSelectChange={onCategoryChange}
      select2Value={selectedDeaneryId}
      select2Placeholder="All Deaneries"
      select2Options={deaneryOptions}
      onSelect2Change={onDeaneryChange}
      searchValue={searchKey}
      searchPlaceholder="Search by name, Parish ID, city, zip..."
      onSearch={onSearch}
      onClear={onClear}
    />
  );
}
